import { archetypes } from '../data/archetypes';

const CORE_MODES = ['visionary', 'executor', 'innovator', 'analyst', 'strategist', 'relationshipBuilder'];

const safeNumber = (value) => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const sumWeights = (weights) =>
  Object.values(weights || {}).reduce((sum, v) => sum + safeNumber(v), 0) || 1;

const scoreArchetype = ({ archetype, percentages }) => {
  const weights = archetype.weights || {};
  const denom = sumWeights(weights);
  const raw = CORE_MODES.reduce((sum, mode) => {
    const w = safeNumber(weights[mode]);
    const p = safeNumber(percentages?.[mode]);
    return sum + w * p;
  }, 0);
  return raw / denom;
};

const getModeContributions = ({ archetype, percentages }) => {
  const weights = archetype.weights || {};
  return CORE_MODES
    .map((mode) => ({
      mode,
      contribution: safeNumber(weights[mode]) * safeNumber(percentages?.[mode]),
    }))
    .sort((a, b) => b.contribution - a.contribution);
};

export const calculateArchetypes = (percentages) => {
  const scored = archetypes
    .map((a) => {
      const score = scoreArchetype({ archetype: a, percentages });
      const contributions = getModeContributions({ archetype: a, percentages });
      const topModes = contributions
        .filter((c) => c.contribution > 0)
        .slice(0, 2)
        .map((c) => c.mode);

      return {
        id: a.id,
        title: a.title,
        description: a.description,
        focus: a.focus,
        watchOut: a.watchOut,
        score: Math.round(score),
        topModes,
      };
    })
    .sort((a, b) => b.score - a.score);

  const primary = scored[0] || null;
  const secondary = scored[1] || null;

  const margin = Math.max(0, (primary?.score || 0) - (secondary?.score || 0));
  const confidenceLabel = margin >= 12 ? 'high' : margin >= 7 ? 'medium' : 'low';

  return {
    primary,
    secondary,
    scores: scored,
    confidence: { label: confidenceLabel, margin },
  };
};

